/**
 * undercover® trust-strip: getallen tellen op zodra ze in beeld komen.
 * De HTML bevat altijd de eindwaarde (zonder JS, bij reduced motion en voor zoekmachines).
 */
(() => {
  if (customElements.get('uc-trust-strip')) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ease = (t) => 1 - Math.pow(1 - t, 3);

  const format = (value, decimals) => value.toFixed(decimals).replace('.', ',');

  class UcTrustStrip extends HTMLElement {
    connectedCallback() {
      const counters = [...this.querySelectorAll('[data-count]')];
      if (!counters.length || reduceMotion.matches || !('IntersectionObserver' in window)) return;
      if (window.Shopify?.designMode) return;

      counters.forEach((el) => {
        el.dataset.final = el.textContent;
        el.textContent = format(0, Number(el.dataset.decimals || 0));
      });

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.observer.unobserve(entry.target);
            this.run(entry.target);
          });
        },
        { threshold: 0.6 }
      );
      counters.forEach((el) => this.observer.observe(el));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    run(el) {
      const target = parseFloat(el.dataset.count);
      const decimals = Number(el.dataset.decimals || 0);
      const duration = 1400;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min((now - start) / duration, 1);
        el.textContent = t < 1 ? format(target * ease(t), decimals) : el.dataset.final;
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  customElements.define('uc-trust-strip', UcTrustStrip);
})();
